import { Grid } from "@material-ui/core";
import React, { useState, useEffect } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import axios from "axios";
import GroupIcon from "@mui/icons-material/Group";
import CategoryIcon from "@mui/icons-material/Category";
import CollectionsBookmarkIcon from "@mui/icons-material/CollectionsBookmark";
import InventoryIcon from "@mui/icons-material/Inventory";
import { DashboardOutlined } from "@material-ui/icons";
import ShoppingCartCheckoutIcon from "@mui/icons-material/ShoppingCartCheckout";
import CheckroomIcon from "@mui/icons-material/Checkroom";
import BrushIcon from "@mui/icons-material/Brush";
import GestureIcon from "@mui/icons-material/Gesture";
import FormatSizeIcon from "@mui/icons-material/FormatSize";
import AuthLoading from "../Auth/AuthLoading";
import MainAppbar from "./Layout/MainAppbar";
import Sidebar from "./Layout/Sidebar";
import Constants from "../Variables/Constants";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';

// Lazy load components for better performance
const AddCategory = React.lazy(() => import("../../AddViews/AddCategory"));
const UpdateCategory = React.lazy(() => import("../../UpdateViews/UpdateCategory"));
const AddSubCategory = React.lazy(() => import("../../AddViews/AddSubCategory"));
const AddStyles = React.lazy(() => import("../../AddViews/AddStyles"));
const AddFabric = React.lazy(() => import("../../AddViews/AddFabric"));
const AddFabricType = React.lazy(() => import("../../AddViews/AddFabricType"));
const AddDesign = React.lazy(() => import("../../AddViews/AddDesign"));
const AddThread = React.lazy(() => import("../../AddViews/AddThread"));
const UpdateSubCategory = React.lazy(() => import("../../UpdateViews/UpdateSubCategory"));
const UpdateStyles = React.lazy(() => import("../../UpdateViews/UpdateStyles"));
const UpdateFabric = React.lazy(() => import("../../UpdateViews/UpdateFabric"));
const UpdateFabricType = React.lazy(() => import("../../UpdateViews/UpdateFabricType"));
const UpdateDesign = React.lazy(() => import("../../UpdateViews/UpdateDesign"));
const UpdateThread = React.lazy(() => import("../../UpdateViews/UpdateThread"));
const AddProducts = React.lazy(() => import("../../AddViews/AddProducts"));
const Add_Testimonial = React.lazy(() => import("../../AddViews/AddTestimonials"));
const Update_Testimonial = React.lazy(() => import("../../UpdateViews/UpdateTestimonial"));
const UpdateProducts = React.lazy(() => import("../../UpdateViews/UpdateProducts"));
const Variants = React.lazy(() => import("./Variants"));
const AddVariants = React.lazy(() => import("../../AddViews/AddVariants"));
const UpdateVariants = React.lazy(() => import("../../UpdateViews/UpdateVariants"));
const Order_Details = React.lazy(() => import("./OrderDetails"));
const AddSize = React.lazy(() => import("../../AddViews/AddSize"));
const UpdateSize = React.lazy(() => import("../../UpdateViews/UpdateSize"));
const UpdateAddOn = React.lazy(() => import("../../UpdateViews/UpdateAddOn"));
const CreateAddOn = React.lazy(() => import("../../AddViews/CreateAddOn"));

const Dashboard = React.lazy(() => import("../Main/Dashboard"));
const UserList = React.lazy(() => import("../Main/UserList"));
const Subcategory = React.lazy(() => import("../Main/Subcategory"));
const Fabric = React.lazy(() => import("../Main/Fabric"));
const FabricType = React.lazy(() => import("../Main/FabricType"));
const Design = React.lazy(() => import("../Main/Design"));
const Thread = React.lazy(() => import("../Main/Thread"));
const Category = React.lazy(() => import("../Main/Category"));
const Products = React.lazy(() => import("../Main/Product"));
const CustomProducts = React.lazy(() => import("../Main/Custom_Product"));
const Orders = React.lazy(() => import("../Main/Orders"));
const Size = React.lazy(() => import("../Main/Size"));
const AddOn = React.lazy(() => import("../Main/AddOn"));

const Main = ({toggleTheme,themeMode}) => {
  const [loading, setLoading] = useState(true);
  const [authenticated, setAuthenticated] = useState(false);
  const [profileData, setProfileData] = useState({ role: "" });

  const checkAuth = (status) => {
    if (status) {
      setLoading(false);
      setAuthenticated(true);
      getProfile();
    } else {
      setLoading(false);
      setAuthenticated(false);
    }
  };

  const getProfile = async () => {
    try {
      const response = await axios.get(Constants.getUrls.getProfile);
      if (response.data.status === "success") {
        setProfileData(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching profile:", error);
    }
  };

  // Route configuration for better maintainability
  const adminRoutes = [
    { path: "/admin/addTestimonial", component: Add_Testimonial, isActive: profileData.role === "admin" },
    { path: "/admin/updateTestimonial", component: Update_Testimonial, isActive: profileData.role === "admin" },
    { path: "/admin/addcategory", component: AddCategory, isActive: profileData.role === "admin" },
    { path: "/admin/updatecategorys/", component: UpdateCategory, isActive: profileData.role === "admin" },
    { path: "/admin/addsubcategory", component: AddSubCategory, isActive: profileData.role === "admin" },
    { path: "/admin/updatesubcategorys/", component: UpdateSubCategory, isActive: profileData.role === "admin" },
    { path: "/admin/addproducts", component: AddProducts, isActive: profileData.role === "admin" },
    { path: "/admin/updateproducts", component: UpdateProducts, isActive: profileData.role === "admin" },
    { path: "/admin/variants/", component: Variants, isActive: profileData.role === "admin" },
    { path: "/admin/addvariants/", component: AddVariants, isActive: profileData.role === "admin" },
    { path: "/admin/updatevariants/", component: UpdateVariants, isActive: profileData.role === "admin" },
    { path: "/admin/orderDetails", component: Order_Details, isActive: profileData.role === "admin" },
    { path: "/admin/addstyles", component: AddStyles, isActive: profileData.role === "admin" },
    { path: "/admin/addfabric", component: AddFabric, isActive: profileData.role === "admin" },
     { path: "/admin/addfabricType", component: AddFabricType, isActive: profileData.role === "admin" },
    { path: "/admin/adddesign", component: AddDesign, isActive: (profileData.role === "admin" || profileData.role === "design_admin") },
    { path: "/admin/updatestyles/", component: UpdateStyles, isActive: profileData.role === "admin" },
    { path: "/admin/updatefabric/", component: UpdateFabric, isActive: profileData.role === "admin" },
       { path: "/admin/updatefabricType/", component: UpdateFabricType, isActive: profileData.role === "admin" },
    { path: "/admin/updatedesign/", component: UpdateDesign, isActive: (profileData.role === "admin" || profileData.role === "design_admin") },
    { path: "/admin/add/thread", component: AddThread, isActive: profileData.role === "admin" },
    { path: "/admin/updatethread", component: UpdateThread, isActive: profileData.role === "admin" },
    { path: "/admin/addSize", component: AddSize, isActive: profileData.role === "admin" },
    { path: "/admin/updateSize", component: UpdateSize, isActive: profileData.role === "admin" },
    { path: "/admin/addon", component: AddOn, isActive: profileData.role === "admin" },
    { path: "/admin/add/addon", component: CreateAddOn, isActive: profileData.role === "admin" },
    { path: "/admin/update/addon/:id", component: UpdateAddOn, isActive: profileData.role === "admin" },


  ];

  const routes = [
    {
      title: "Dashboard",
      path: "/dashboard",
      component: Dashboard,
      icon: <DashboardOutlined style={{ fontSize: "20" }} />,
      exact: true,
      isActive: profileData.role === "admin"
    },
    {
      title: "Category",
      path: "/category",
      component: Category,
      icon: <CategoryIcon style={{ fontSize: "20" }} />,
      exact: true,
      isActive: profileData.role === "admin"
    },
    {
      title: "Collection",
      path: "/collection",
      component: Subcategory,
      icon: <CollectionsBookmarkIcon style={{ fontSize: "20" }} />,
      exact: true,
      isActive: profileData.role === "admin"
    },
    {
      title: "Products",
      path: "/products",
      component: Products,
      icon: <InventoryIcon style={{ fontSize: "20" }} />,
      exact: true,
      isActive: profileData.role === "admin"
    },
      {
      title: "Custom Products",
      path: "/custom-products",
      component: CustomProducts,
      icon: <InventoryIcon style={{ fontSize: "20" }} />,
      exact: true,
      isActive: profileData.role === "admin"
    },
    {
      title: "User List",
      path: "/userList",
      component: UserList,
      icon: <GroupIcon style={{ fontSize: "20" }} />,
      exact: true,
      isActive: profileData.role === "admin"
    },
    {
      title: "Orders",
      path: "/orders",
      component: Orders,
      icon: <ShoppingCartCheckoutIcon style={{ fontSize: "20" }} />,
      exact: true,
      isActive: profileData.role === "admin"
    },
    {
      title: "Fabric",
      path: "/fabrics",
      component: Fabric,
      icon: <CheckroomIcon style={{ fontSize: "20" }} />,
      exact: true,
      isActive: profileData.role === "admin"
    },
    {
      title: "Fabric Type",
      path: "/fabricTypes",
      component: FabricType,
      icon: <CheckroomIcon style={{ fontSize: "20" }} />,
      exact: true,
      isActive: profileData.role === "admin"
    },
    {
      title: "Design",
      path: "/design",
      component: Design,
      icon: <BrushIcon style={{ fontSize: "20" }} />,
      exact: true,
      isActive: (profileData.role === "admin" || profileData.role === "design_admin")
    },
    {
      title: "Thread",
      path: "/thread",
      component: Thread,
      icon: <GestureIcon style={{ fontSize: "20" }} />,
      exact: true,
      isActive: profileData.role === "admin"
    },
    {
      title: "Size",
      path: "/size",
      component: Size,
      icon: <FormatSizeIcon style={{ fontSize: "20" }} />,
      exact: true,
      isActive: profileData.role === "admin"
    },
    {
      title: "AddOn",
      path: "/addon",
      component: AddOn,
      icon: <AddCircleOutlineIcon style={{ fontSize: "20" }} />,
      exact: true,
      isActive: profileData.role === "admin"
    }
  ];

  if (loading) {
    return <AuthLoading checkAuth={checkAuth} />;
  }

  if (!authenticated && !loading) {
    return null;
  }

  return (
    <div>
      <MainAppbar toggleTheme={toggleTheme}themeMode={themeMode} />
      <Grid container className="main">
        <Grid
          item
          style={{
            position: "fixed",
            width: "16.666667%",
            marginTop: "70px",
          }}
          className="sidebar"
        >
          <Sidebar />
        </Grid>

        <Grid item xs={2} style={{ margin: "12px 0" }}></Grid>

        <Grid item xs={10} spacing={2} style={{ margin: "90px 0" }}>
          <React.Suspense fallback={<div>Loading...</div>}>
            <Switch>
              <Route exact path="/">
                <Redirect to="/dashboard" />
              </Route>
              {routes.filter(io => io.isActive === true).map((route, index) => (
                <Route
                  exact={route.exact}
                  path={route.path}
                  render={() => <route.component title={route.title} />}
                  key={index}
                />
              ))}
              {adminRoutes.filter(io => io.isActive === true).map((route, index) => (
                <Route
                  key={`admin-${index}`}
                  path={route.path}
                  component={route.component}
                />
              ))}
            </Switch>
          </React.Suspense>
        </Grid>
      </Grid>
    </div>
  );
};

export default Main;